import axios from "axios";
import router from "../router";
import { insertInstanceRules, createCsrfAndGetCookie } from "./CsrfService";
import store from "@/store";

export default () => {
    let sourceRequest = {};
    let headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
    };

    let instance = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        headers
    });
    const controller = new AbortController();

    axios.defaults.withCredentials = true;
    instance.defaults.withCredentials = true;
    insertInstanceRules(instance);
    instance.interceptors.request.use(
        async request => {
            if (sourceRequest[request.url]) {
                controller.abort();
            }
            const source = axios.CancelToken.source();
            request.cancelToken = source.token;
            source.url = request.url;
            store.commit("app/addCancelToken", source);
            if (!request.params) request.params = {};
            request.params["ts"] = new Date().getTime();

            return request;
        },
        function(error) {
            return Promise.reject(error);
        }
    );
    instance.interceptors.response.use(
        response => {
            return response;
        },
        async error => {
            if (error?.response?.status === 401) {
                localStorage.removeItem("jwt_token");
                localStorage.removeItem("pt_user");
                router.push("/login");
                return error.response.data.message;
            }
            if (error.response?.status === 403) {
                //router.push("/");
                return error.response.data.message;
            }
            if (
                error?.response?.data?.message?.constructor === String &&
                error.response.data.message &&
                error.response.data.message.match(/\sCSRF/g) &&
                error.response.data.message.match(/\sCSRF/g).length > 0
            ) {
                const csrfCookie = await createCsrfAndGetCookie();
                if (csrfCookie) {
                    instance.defaults.headers.common["X-CSRF-TOKEN"] = csrfCookie;
                    headers["X-CSRF-TOKEN"] = csrfCookie;
                    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfCookie;
                }
            }
            if (error.response) {
                return error.response.data;
            } else {
                return Promise.reject(error);
            }
        }
    );

    return instance;
};
